
<form #f="ngForm">

	<div class="form-group row">
		<label class="col-lg-2 offset-lg-3 col-form-label">{{ 'FE.ORDER.FORMS.LABELS.COMMON.CITY' | localize }}<i class="text-danger">*</i></label>
		<div class="col-lg-4 kt-margin-b-10-tablet-and-mobile">
			<mat-select class="form-control"
						placeholder="{{ 'FE.ORDER.FORMS.PLACEHOLDERS.COMMON.CITY' | localize }}"
						[(ngModel)]="selectCityId"
						name="city"
						#city="ngModel"
						(selectionChange)="onChangeCity()"
						required>
				<mat-option>
					{{ 'FE.ORDER.FORMS.COMBOBOX.COMMON.CHOOSE' | localize }}

				</mat-option>
				<mat-option *ngFor="let city of (cities | async)" [value]="city.cityId">{{city.cityName}}</mat-option>
			</mat-select>

			<div *ngIf="city.invalid && (city.dirty || city.touched)"
				 class="mat-error">
				<div *ngIf="city.errors.required">
					{{ 'FE.REQUIREDFIELDS.COMMON.REQUIRED' | localize }}
				</div>
			</div>
			<!--<mat-error *ngIf="city.hasError('required')">Bu Alan Boş Bırakılamaz</mat-error>-->
			<!-- <span *ngIf="isRequiredCityMessage" class="help-block" style="color: tomato;">Bu Alan Boş Bırakılamaz</span> -->
		</div>
	</div>

	<div class="form-group row">
		<label class="col-lg-2 offset-lg-3 col-form-label">{{ 'FE.ORDER.FORMS.LABELS.COMMON.DISTRICT' | localize }}<i class="text-danger">*</i></label>
		<div class="col-lg-4 kt-margin-b-10-tablet-and-mobile">
			<mat-select class="form-control"
						placeholder="{{ 'FE.ORDER.FORMS.PLACEHOLDERS.COMMON.DISTRICT' | localize }}"
						[(ngModel)]="selectDistrictId"
						name="district"
						#district="ngModel"
						(selectionChange)="onChangeDistrict()"
						required>
				<mat-option>
					{{ 'FE.ORDER.FORMS.COMBOBOX.COMMON.CHOOSE' | localize }}

				</mat-option>
				<mat-option *ngFor="let district of (districts | async)" [value]="district.districtId">
					{{district.districtName}}
				</mat-option>
			</mat-select>

			<div *ngIf="district.invalid && (district.dirty || district.touched)"
				 class="mat-error">
				<div *ngIf="district.errors.required">
					{{ 'FE.REQUIREDFIELDS.COMMON.REQUIRED' | localize }}
				</div>
			</div>
			<!-- <span *ngIf="isRequiredDistrictMessage" class="help-block" style="color: tomato;">Bu Alan Boş Bırakılamaz</span> -->
			<!--<mat-error *ngIf="district.hasError('required')">Bu Alan Boş Bırakılamaz</mat-error>-->

		</div>
	</div>
	<div class="form-group row">
		<label class="col-lg-2 offset-lg-3 col-form-label">
			{{ 'FE.ORDER.FORMS.LABELS.ADDADDRESSTOPERSON.DESTINATIONLOCATION' | localize }}
			<i class="la la-info-circle la-lg text-danger" placement="top" ngbTooltip="{{ 'FE.ORDER.FORMS.LABELS.ADDADDRESSTOPERSON.ICONS.TOOLTIP.DESTINATIONADDRES' | localize }}" ngbTooltipClass="kt-tooltip"></i>
			<i class="text-danger">*</i>
		</label>
		<div class="col-lg-4 kt-margin-b-10-tablet-and-mobile">
			<input class="form-control"
				   type="text"
				   placeholder="{{ 'FE.ORDER.FORMS.PLACEHOLDERS.ADDADDRESSTOPERSON.DESTINATIONLOCATION' | localize }}"
				   aria-label="Assignee"
				   [formControl]="myControl"
				   [matAutocomplete]="auto"
				   [(ngModel)]="selectAddress"
				   name="address"
				   (keyup)="onKeyupCustomAddress()"
				   required>
			<!-- <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn"> -->
			<mat-autocomplete #auto="matAutocomplete">
		
				<mat-option *ngFor="let location of (filteredOptions | async)" [value]="location.name" (click)='onClickSelectedLocation(location)'>
					{{ location.name }}
				</mat-option>
			</mat-autocomplete>

			<div *ngIf="myControl.invalid && (myControl.dirty || myControl.touched)"
				 class="mat-error">
				<!--<div *ngIf="myControl.errors.required">
					{{ 'FE.REQUIREDFIELDS.COMMON.REQUIRED' | localize }}
				</div>-->
				</div>
			<!--<mat-error *ngIf="myControl.hasError('required')">Bu Alan Boş Bırakılamaz</mat-error>-->
			<!--<span *ngIf="isRequiredAddressMessage" class="help-block" style="color: tomato;">Bu Alan Boş Bırakılamaz</span>-->
		</div>
	</div>



	<div class="form-group row">
		<label class="col-lg-2 offset-lg-3 col-form-label">{{ 'FE.ORDER.FORMS.LABELS.ADDADDRESSTOPERSON.DESTINATIONADDRESS' | localize }}</label>
		<div class="col-lg-4 kt-margin-b-10-tablet-and-mobile">
			<textarea class="form-control"
					  placeholder="{{ 'FE.ORDER.FORMS.PLACEHOLDERS.ADDADDRESSTOPERSON.DESTINATIONADDRESS' | localize }}"
					  rows="3"
					  [(ngModel)]="selectFullAddress"
					  name="openAddress"
					  #openAddress="ngModel"
					  [disabled]="isFullAddress"
					  (blur)="onBlurFullAddress()"></textarea>
			<!--<mat-error *ngIf="openAddress.hasError('required')">{{ 'FE.REQUIREDFIELDS.COMMON.REQUIRED' | localize }}</mat-error>-->

			<!-- <span *ngIf="isRequiredFullAddressMessage" class="help-block" style="color: tomato;">Bu Alan Boş Bırakılamaz</span> -->
		</div>
	</div>
</form>
